/** Consume a string of target Ids like "id1,id2" and return an array of TargetModels */
export function getTargetIdsFromConjoinedString(
  stringOfTargets = "",
  combatantsDataset = {}
) {
  return stringOfTargets.split(",").map(id => {
    if (!Boolean(combatantsDataset[id])) {
      console.warn("id not found in combatantsDataset", id, combatantsDataset);
    }

    return combatantsDataset[id];
  });
}



// WEBPACK FOOTER //
// ./src/battle/get-target-ids-from-conjoined-string.js